module platform {

   export class WebsocketMessagingService {
      static $inject = ["$injector"];
      private _vscWebsocketMessagingService: WebsocketMessagingService;

      constructor(private $injector: any) {
      }

      get vscWebsocketMessagingService() {
         if (!this._vscWebsocketMessagingService) {
            this._vscWebsocketMessagingService =
                  this.$injector.get("vscWebsocketMessagingService");
         }
         return this._vscWebsocketMessagingService;
      }

      initialize(url: string): WebSocket | null {
         return this.vscWebsocketMessagingService.initialize(url);
      }

      /**
       * Creates a live-updates websocket and returns a promise, resolved with a
       * function that sends a SUBSCRIBE message for a specified topic.
       */
      initializeLiveUpdates(): angular.IPromise<(destination: string) => void> {
         return this.vscWebsocketMessagingService.initializeLiveUpdates();
      }

      send(msg: string): void {
         this.vscWebsocketMessagingService.send(msg);
      }

      /**
       * Subscribe for APIGW notifications for given componentId and nodeUuid.
       * If we are already listening for notifications for componentId/serverGuid
       * then we just increase the count of the subscribed views.
       * Otherwise we sent subscribe websocket message for the componentId/serverGuid
       * pair.
       */
      subscribeForNotifications(componentId: string, nodeUuid: string): void {
         this.vscWebsocketMessagingService
               .subscribeForNotifications(componentId, nodeUuid);
      }

      /**
       * Subscribe for APIGW notifications for given componentId and nodeUuid.
       * If there are more than one views that are subscribed for componentId/serverGuid pair
       * then we just decrement the subscription counter by one.
       */
      unsubscribeForNotifications(componentId: string, nodeUuid: string): void {
         this.vscWebsocketMessagingService
               .unsubscribeForNotifications(componentId, nodeUuid);
      }
   }

   /**
    * @ngdoc service
    * @name com.vmware.platform.ui.websocketMessagingService
    * @module com.vmware.platform.ui
    *
    * @description
    *    Utility methods for fetching resource framework data and metadata.
    *
    * @private
    *    TODO mibryamov: remove this service when its consumers are removed
    *    from AngularJS - ObjectListViewController and NaviObjectListViewController
    */
   angular.module('com.vmware.platform.ui')
         .service('websocketMessagingService', WebsocketMessagingService);
}
